// extracted by mini-css-extract-plugin
module.exports = {"newsItem":"NewsItem_newsItem_5emT6","clip-img-wrapper":"NewsItem_clip-img-wrapper_IVDme"};